<div class="file-manager-quota">
    <div class="file-manager-quota__label">Tárhely</div>
    <div class="file-manager-quota__stats">
        <span class="file-manager-quota__detail">Feltöltve: {{ usedLabel() }}</span>
        <span class="file-manager-quota__capacity">{{ totalLabel() }}</span>
    </div>
    <div class="file-manager-quota__progress">
        <div class="file-manager-quota__progress-bar" [style.width]="progressWidth()"></div>
    </div>
    <div class="file-manager-quota__percent">{{ percent() }}%</div>
</div>
